export class AANScrollTop {
	private scrollTopElement?: HTMLElement;

	private scrollTopVisible() {
		const windowHeight: number = window.innerHeight
			|| Math.max(document.documentElement.clientHeight, document.body.clientHeight);
		const showpoint: number = windowHeight / 2;

		if (document.documentElement.scrollTop > showpoint) {
			this.scrollTopElement?.classList.add("visible");
		} else {
			this.scrollTopElement?.classList.remove("visible");
		}
	}

	init(): void {
		this.scrollTopElement = document.querySelector(".scroll-top") as HTMLElement;

		if (!this.scrollTopElement) {
			return;
		}

		this.scrollTopVisible();

		window.addEventListener("scroll", () => {
			this.scrollTopVisible();
		});

		this.scrollTopElement.addEventListener("click", () => {
			const windowHeight: number = document.documentElement.scrollTop;
			const animationLength = 500; // milliseconds
			const stepUnit = Math.ceil(windowHeight / (animationLength / 10));

			const scrollAnimation = () => {
				window.scrollTo(document.documentElement.scrollLeft, document.documentElement.scrollTop - stepUnit);

				if (document.documentElement.scrollTop <= 10) {
					return;
				}

				setTimeout(scrollAnimation, 10);
			};

			scrollAnimation();
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const scrollTop = new AANScrollTop();

	scrollTop.init();
});
